export default {
    ui: {
        helpAria: "Open tutorial for this section",
        slideOf: "Slide {{current}} of {{total}}",
        getStarted: "Get started",
        dialogIntro: "Introduction to this area",
        goToSlide: "Go to slide {{n}} of {{total}}",
    },
    shipper: {
        askEve: {
            label: "Ask Eve",
            mockUi: {
                eveName: "Eve",
                assistantSubtitle: "AI assistant",
                typingStatus: "Typing",
                yourMessage: "You",
                eveReply: "Eve",
                composeTitle: "Write your message",
                placeholder: "Ask a question…",
                send: "Send",
            },
            slides: [
                {
                    title: "Welcome to Ask Eve",
                    body: "Your AI assistant for shipments, documents, and next steps. Ask questions in plain language and get answers grounded in your workspace.",
                    mock: "eve-chat-intro",
                },
                {
                    title: "Context-aware help",
                    body: "Eve can suggest actions, summarize status, and highlight risks using the same data you see elsewhere in EveMind—without jumping between pages.",
                    mock: "eve-context-cards",
                },
                {
                    title: "Keep the conversation going",
                    body: "Follow up in the same thread to refine a request, add detail, or explore a different angle on the same topic.",
                    mock: "eve-thread",
                },
                {
                    title: "You are in control",
                    body: "When you are ready, close this tour and type your first question in the chat. You can reopen this guide anytime with the help button.",
                    mock: "eve-compose",
                },
            ],
        },
        controlHub: {
            label: "Control Hub",
            slides: [
                {
                    title: "Your Control Hub",
                    body: "A single place to see how your operation is performing and where to focus today—before you dive into individual modules.",
                    mock: "hub-hero-cards",
                },
                {
                    title: "Priorities at a glance",
                    body: "Key metrics and signals help you spot delays, risk, and workload without opening every area of the application.",
                    mock: "hub-kpis",
                },
                {
                    title: "From insight to action",
                    body: "Use the hub to jump into operations, coordination, or commercial flows with the context you need to decide quickly.",
                    mock: "hub-shortcuts",
                },
                {
                    title: "Ready to explore",
                    body: "Close this introduction and browse the hub. This tour will not appear again unless you open it from the help button.",
                    mock: "hub-ready",
                },
            ],
        },
        operations: {
            label: "Operations",
            slides: [
                {
                    title: "Operations workspace",
                    body: "Manage containers, follow live tracking, and keep documents organized—your core day-to-day operational area as a shipper.",
                    mock: "ops-modules",
                },
                {
                    title: "Containers and tracking",
                    body: "Monitor milestones, routes, and status updates so you know what is moving, what is delayed, and what needs attention.",
                    mock: "ops-route",
                },
                {
                    title: "Documents in one place",
                    body: "Upload, classify, and find shipping documents linked to your shipments so validation and handovers stay fast and consistent.",
                    mock: "ops-files",
                },
                {
                    title: "Dive in",
                    body: "Choose Containers, Live tracking, or Documents from the sidebar. You can replay this tour anytime via the help button.",
                    mock: "ops-nav-hint",
                },
            ],
        },
        coordination: {
            label: "Coordination",
            slides: [
                {
                    title: "Stay coordinated",
                    body: "Activity, issues, and the review center work together so teams see what changed, what broke, and what still needs a human decision.",
                    mock: "coord-pillars",
                },
                {
                    title: "Activity feed",
                    body: "Follow a chronological stream of notifications and updates across your shipments so nothing important is buried in email.",
                    mock: "coord-feed",
                },
                {
                    title: "Issues and review",
                    body: "Track open problems and pending reviews in one place—resolve blockers and approvals before they turn into delays or extra cost.",
                    mock: "coord-tickets",
                },
                {
                    title: "Stay on top",
                    body: "Visit these areas regularly to clear blockers early. Close the tour when you are ready to start from the sidebar.",
                    mock: "coord-rhythm",
                },
            ],
        },
        commercial: {
            label: "Commercial",
            slides: [
                {
                    title: "Commercial flows",
                    body: "Handle orders and freight quotes in one macro-area aligned with how you buy, sell, and move cargo.",
                    mock: "comm-bridge",
                },
                {
                    title: "Orders",
                    body: "Create and monitor orders linked to your logistics pipeline so commercial intent stays tied to execution.",
                    mock: "comm-order-card",
                },
                {
                    title: "Quotes",
                    body: "Request and compare freight quotes so you can balance price, service level, and timelines for each shipment.",
                    mock: "comm-quote-compare",
                },
                {
                    title: "Close the loop",
                    body: "Move from commercial decisions to operations without losing context. Close this tour to continue in Orders or Quotes.",
                    mock: "comm-handoff",
                },
            ],
        },
        network: {
            label: "Network",
            slides: [
                {
                    title: "Your network",
                    body: "Partners, team members, and contacts are the backbone of reliable shipping—this area keeps them organized.",
                    mock: "net-graph",
                },
                {
                    title: "Business partners",
                    body: "Maintain relationships with forwarders, carriers, and counterparties you work with so every shipment references the right party.",
                    mock: "net-partner-cards",
                },
                {
                    title: "Team and access",
                    body: "Invite colleagues and manage who can view or act on your company data—essential for safe collaboration.",
                    mock: "net-team-row",
                },
                {
                    title: "Address book",
                    body: "Centralize contacts and locations so forms and documents stay consistent. Close the tour when you are ready to browse.",
                    mock: "net-contact-card",
                },
            ],
        },
    },
};
